// removed by extract-text-webpack-plugin
module.exports = {"text-wrap":"_3XEsRxWDfGaSVXBP5EuiQo_0","glitch":"_2rbM7_eP0iFpeIkKhqmC6E_0","glitch-1":"_21BJUOqYiujSzey5wRon9T_0","glitch-2":"_1a9AoINJOtjKOhk1fbCpPj_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ad736ba","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/glitchtext.vue
// module id = M57x
// module chunks = 0